module.exports = "<p *ngIf=\"this.showError === 1\">\r\n  Please enter correct email or password!!\r\n</p>\r\n"